import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createContext, useContext } from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var CardContext = /*#__PURE__*/createContext(null);
export var CardProvider = CardContext.Provider;
export var CardContextProvider = function CardContextProvider(_ref) {
  var value = _ref.value,
      children = _ref.children;
  return _jsx(CardContext.Provider, {
    value: _objectSpread({}, value),
    children: children
  });
};
export var useCardContext = function useCardContext() {
  var state = useContext(CardContext);

  if (state === null) {
    throw new Error("Card context isn't available.");
  }

  return state;
};